import React, { Component } from "react";
import blurLoading from "../assets/images/blurLoading.png";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = process.env.PUBLIC_URL || "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="bg-[url('assets/images/bgLoading.jpg')] bg-cover bg-fixed bg-center min-h-screen relative flex items-center justify-center px-4 overflow-hidden">
          
          {/* Blur effect at the bottom left */}
          <img
            src={blurLoading}
            alt="blurLoading"
            className="absolute bottom-0 left-0 pointer-events-none"
          />

          <div className="text-center relative z-10 max-w-lg mb-20 bg-black/40 p-10 rounded-2xl backdrop-blur-sm border border-[#FBE67B]/20">
            {/* Error Icon */}
            <div className="mb-6 inline-flex items-center justify-center w-24 h-24 rounded-full bg-red-500/10 border border-red-500/30">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-12 w-12 text-red-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={1.5}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                />
              </svg>
            </div>

            {/* Message */}
            <h2 className="text-2xl md:text-3xl font-semibold text-white mb-3">
              Đã xảy ra lỗi
            </h2>
            <p className="text-gray-300 text-base md:text-lg mb-8 leading-relaxed">
              Ứng dụng gặp sự cố không mong muốn. Vui lòng thử tải lại trang
              hoặc quay về trang chủ.
            </p>

            {/* Actions */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <button
                onClick={this.handleReload}
                className="inline-flex items-center gap-2 px-6 py-3.5 bg-[#FBE67B] text-black font-semibold rounded-full shadow-lg shadow-[#FBE67B]/25 hover:shadow-[#FBE67B]/40 transition-all duration-300 hover:scale-105 active:scale-95"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182"
                  />
                </svg>
                Tải lại trang
              </button>

              <button
                onClick={this.handleGoHome}
                className="inline-flex items-center gap-2 px-6 py-3.5 border-2 border-[#FBE67B] text-[#FBE67B] font-semibold rounded-full hover:bg-[#FBE67B]/10 transition-all duration-300 hover:scale-105 active:scale-95"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                  />
                </svg>
                Trang chủ
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
